import { convertToTitleCase } from '@utils/methods';

export const maskSSN = v => {
  return v.length === 9 ? `XXX-XX-${v.substr(5)}` : '';
};

export const objHasStuff = v => {
  const bList = ['patientid', 'id', '__v', '_id'];
  const arrResult = Object.keys(v).map(key => {
    if (!bList.includes(key)) {
      if (v[key] !== null && v[key] !== '') return true;
    }
    return false;
  });
  return arrResult.includes(true);
};

export const strip = html => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const petroleum = (c, r, reportContent) => {
  return c.replace(r, matched => {
    return reportContent[matched];
  });
};

export const occupationWithArticle = y => {
  const x = y[0].toUpperCase();
  const result = x === 'A' || x === 'E' || x === 'I' || x === 'O' || x === 'U';
  return result ? `an ${y}` : `a ${y}`;
};

export const dateToday = () => {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const date = new Date();
  const d = date.getDate();
  const day = d < 10 ? `0${d}` : d;
  // const m = date.getMonth() + 1;
  // const month = (m < 10) ? `0${m}` : m;
  const yy = date.getYear();
  const year = yy < 1000 ? yy + 1900 : yy;
  return `${monthNames[date.getMonth()]} ${day}, ${year}`;
};

export const getAge = dateString => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

export const multiEndx = s => {
  const x = s.split(',');
  let fin = '';
  if (s === '') return '';
  if (x.length > 1) {
    for (const l in x) {
      if (+l === x.length - 1) {
        fin += `and ${x[l].trim()}`;
        return fin;
      } else {
        fin += `${x[l].trim()}, `;
      }
    }
  } else if (x.length === 1) {
    return x[0];
  }
  return fin;
};

export const multiEnd = s => {
  if (s.trim().substring(s.trim().length - 1, s.trim().length) === ',') {
    return s
      .trim()
      .substring(0, s.trim().length - 1)
      .replace(/,([^,]*)$/, ' and $1')
      .toLowerCase();
  }
  return multiEndx(s.trim());
};

export const isPreauthApproved = pauth => {
  if (pauth) {
    const preAuthCaves = [pauth.pre30 !== '' && pauth.pre30 === 'APPROVED', pauth.pre24 !== '' && pauth.pre24 === 'APPROVED', pauth.pre18 !== '' && pauth.pre18 === 'APPROVED'];
    return preAuthCaves.includes(true);
  }
  return false;
};

export const isPreauth4600 = pauth => {
  if (pauth) {
    const preAuthCaves = [pauth.pre30 !== '' && pauth.pre30 === 'ATTY 4600 LETTER', pauth.pre24 !== '' && pauth.pre24 === 'ATTY 4600 LETTER', pauth.pre18 !== '' && pauth.pre18 === 'ATTY 4600 LETTER'];
    return preAuthCaves.includes(true);
  }
  return false;
};

export const isPreauthNoAnswer = pauth => {
  if (pauth) {
    const preAuthCaves = [pauth.pre30 !== '' && pauth.pre30 === 'NO ANSWER', pauth.pre24 !== '' && pauth.pre24 === 'NO ANSWER', pauth.pre18 !== '' && pauth.pre18 === 'NO ANSWER'];
    return !preAuthCaves.includes(false) && (!isPreauthApproved(pauth) || !isPreauth4600(pauth));
  }
  return false;
};

export const isPreauthOther = pauth => {
  if (pauth) {
    const preAuthCaves = [pauth.pre30 !== '' && pauth.pre30 === 'OTHER', pauth.pre24 !== '' && pauth.pre24 === 'OTHER', pauth.pre18 !== '' && pauth.pre18 === 'OTHER'];
    return preAuthCaves.includes(true);
  }
  return false;
};

export const trimLast = (v, t) => {
  return v.trim().slice(-1) !== t ? v : v.trim().substring(0, v.trim().length - 1);
};

export const heShePronoun = gender => {
  return gender.toUpperCase() === 'MALE' ? 'he' : 'she';
};

export const hisHerPossessive = gender => {
  return gender.toUpperCase() === 'MALE' ? 'his' : 'her';
};

export const mrMsArticle = (cname, gender) => (gender === 'Male' ? 'Mr. ' : 'Ms. ') + cname;

export const randomArticle = (cname, gender) => {
  // console.log('[randomArticle] ', gender);
  const artx = [gender === 'MALE' || gender === 'Male' ? 'He' : 'She', 'The patient', (gender === 'MALE' || gender === 'Male' ? 'Mr. ' : 'Ms. ') + cname];
  return artx[Math.floor(Math.random() * (2 - 0 + 1)) + 0];
};

export const unDefNullSpace = values => {
  const x = /\[ref/i;
  for (var key in values) {
    if (values.hasOwnProperty(key)) {
      if (values[key] === undefined || values[key] === null) {
        values[key] = '';
      } else {
        if (typeof values[key] === 'string') {
          if (values[key].match(x) !== null) {
            values[key] = '';
          } else {
            values[key] = values[key].trim();
          }
        }
        if (typeof values[key] === 'object') {
          if (values[key].toString().match(x) !== null) {
            values[key] = 'None';
          } else {
            values[key] = values[key].toString().trim();
          }
        }
      }
    }
  }

  return values;
};

const psSwitches = ['psbodypartpain', 'psupperbackpain', 'pslowerbackpain', 'psleftshoulderpain', 'psleftshoulderpain', 'psleftelbowpain', 'psleftelbowpain', 'psleftwristpain', 'pspsleftankleandfootpainpain', 'pspsleftankleandfootpainpain', 'psleftkneepain', 'psleftkneepain', 'psleftankleandfootpain', 'psleftankleandfootpain'];

const checkNullSpace = v => {
  return v !== '' && v !== null;
};

const excludedFields = ['hwf', 'lr', 'patientid', '_id', '__v'];

export const checkStuffKillZero = (v, pe = false) => {
  let result = false;

  if (!v) return false;
  Object.keys(v).map(key => {
    if (!pe && !excludedFields.includes(key)) {
      if (checkNullSpace(v[key])) {
        if (psSwitches.includes(key) && !v[key]) {
          result = false;
          return key;
        }
        result = true;
      }
    }

    if (pe && key === 'patientid') {
      if (checkNullSpace(v[key])) {
        result = true;
      }
    }

    return key;
  });

  return result;
};

export const checkStuffKillZeroII = w => {
  let result = false;
  if (w.length === 0) return false;
  if (!w) return false;

  w.map(v => {
    Object.keys(v).map(key => {
      if (!excludedFields.includes(key)) {
        if (checkNullSpace(v[key])) {
          if (psSwitches.includes(key) && !v[key]) {
            result = false;
            return key;
          }
          result = true;
        }
      }
      return key;
    });
    return v;
  });
  // console.log('[checkStuffKillZeroII] ', w, result);
  return result;
};

export const setPSTitleByPcode = ps3 => {
  let result = '';
  const pstitle = [
    '<p style="text-align: left;"><b>RIGHT WRIST:</b> ',
    '<p style="text-align: left;"><b>LEFT WRIST:</b> ',
    '<p style="text-align: left;"><b>RIGHT HAND:</b> ',
    '<p style="text-align: left;"><b>LEFT HAND:</b> ',
    '<p style="text-align: left;"><b>CERVICAL SPINE:</b> ',
    '<p style="text-align: left;"><b>NECK:</b> ',
    '<p style="text-align: left;"><b>THORACIC SPINE:</b> ',
    '<p style="text-align: left;"><b>UPPER BACK:</b> ',
    '<p style="text-align: left;"><b>LUMBAR SPINE:</b> ',
    '<p style="text-align: left;"><b>LOWER BACK:</b> ',
    '<p style="text-align: left;"><b>RIGHT SHOULDER:</b> ',
    '<p style="text-align: left;"><b>LEFT SHOULDER:</b> ',
    '<p style="text-align: left;"><b>RIGHT ELBOW:</b> ',
    '<p style="text-align: left;"><b>LEFT ELBOW:</b> ',
    '<p style="text-align: left;"><b>RIGHT HIP:</b> ',
    '<p style="text-align: left;"><b>LEFT HIP:</b> ',
    '<p style="text-align: left;"><b>RIGHT KNEE:</b> ',
    '<p style="text-align: left;"><b>LEFT KNEE:</b> ',
    '<p style="text-align: left;"><b>RIGHT FOOT/ANKLE:</b> ',
    '<p style="text-align: left;"><b>LEFT FOOT/ANKLE:</b> ',
  ];

  pstitle.forEach(function (a) {
    if (a.indexOf(ps3.toUpperCase()) > -1) {
      result = a;
    }
    /*
    if (a.indexOf(ps3.toUpperCase()) > -1 && ps3.toUpperCase() === 'CERVICAL SPINE') {
      result = '<p style="text-align: left;"><b>NECK:</b> ';
    }
    if (a.indexOf(ps3.toUpperCase()) > -1 && ps3.toUpperCase() === 'THORACIC SPINE') {
      result = '<p style="text-align: left;"><b>UPPER BACK:</b> ';
    }
    if (a.indexOf(ps3.toUpperCase()) > -1 && ps3.toUpperCase() === 'LUMBAR SPINE') {
      result = '<p style="text-align: left;"><b>LOWER BACK:</b> ';
    }
    */
  });
  return result;
};

export const replacePercentages = v => {
  const chop = v
    .replace(/ \(25%\)/g, '')
    .replace(/ \(50%\)/g, '')
    .replace(/ \(75%\)/g, '')
    .replace(/ \(90-100%\)/g, '');
  return chop.trim();
};

export const fetchOrthoDiag = (pdiag, pantera) => {  
  const orthoxDiag = {};
  orthoxDiag.bp = [];
  orthoxDiag.c = [];
  orthoxDiag.d = [];

  Object.keys(pdiag)
    .filter(diag => diag.indexOf('diag') > -1 && pdiag[diag] !== '')
    .map(diag => {
      let v;
      let icd;

      if (diag === 'diagcspine') {
        orthoxDiag.bp.push('cervical spine');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Cervical Spine ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagtspine') {
        orthoxDiag.bp.push('thoracic spine');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Thoracic Spine ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglspine') {
        orthoxDiag.bp.push('lumbar spine');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Lumbar Spine ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      //if (diag === 'diagmisc') orthoxDiag.bp.push('cervical spine');

      if (diag === 'diaglshoulder') {
        orthoxDiag.bp.push('left shoulder');
        v = pantera['diaglshoulder'].split(',');
        icd = pantera['diaglshoulderICD'].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Shoulder ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglelbow') {
        orthoxDiag.bp.push('left elbow');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Elbow ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglwrist') {
        orthoxDiag.bp.push('left wrist');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Wrist ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglhand') {
        orthoxDiag.bp.push('left hand');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Hand ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglfinger') {
        orthoxDiag.bp.push('left finger');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Finger ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglthumb') {
        orthoxDiag.bp.push('left thumb');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Thumb ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglhip') {
        orthoxDiag.bp.push('left hip');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Hip ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglknee') {
        orthoxDiag.bp.push('left knee');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Knee ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diaglankfoot') {
        orthoxDiag.bp.push('left foot/ankle');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Foot/Ankle ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagltoe') {
        orthoxDiag.bp.push('left toe');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Left Toe ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }


      if (diag === 'diagrshoulder') {
        orthoxDiag.bp.push('right shoulder');
        v = pantera['diagrshoulder'].split(',');
        icd = pantera['diagrshoulderICD'].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Shoulder ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrelbow') {
        orthoxDiag.bp.push('right elbow');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Elbow ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrwrist') {
        orthoxDiag.bp.push('right wrist');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Wrist ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrhand') {
        orthoxDiag.bp.push('right hand');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Hand ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrfinger') {
        orthoxDiag.bp.push('right finger');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Finger ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrthumb') {
        orthoxDiag.bp.push('right thumb');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Thumb ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrhip') {
        orthoxDiag.bp.push('right hip');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Hip ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrknee') {
        orthoxDiag.bp.push('right knee');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Knee ' + v[j]);
            orthoxDiag.d.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrankfoot') {
        orthoxDiag.bp.push('right foot/ankle');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Foot/Ankle ' + v[j]);
            orthoxDiag.c.push(icd[j]);
          }
        }
      }

      if (diag === 'diagrtoe') {
        orthoxDiag.bp.push('right toe');
        v = pantera[diag].split(',');
        icd = pantera[`${diag}ICD`].split(',');
        for (let j = 0; j <= v.length - 1; j += 1) {
          if (pdiag[diag].indexOf(v[j]) > -1) {
            orthoxDiag.c.push('Right Toe ' + v[j]);
            orthoxDiag.c.push(icd[j]);
          }
        }
      }

      return diag;
    });

  return orthoxDiag;
};

export const getStringFromArray = (arr, fld, reqd, reqdVal = '') => {
  let result = '';
  arr
    .filter(v => v['typeofdoi'] !== '')
    .map(v => {
      if (v[reqd] && v[reqd] !== reqdVal) {
        result += `${v[fld]},`;
      }
      return v;
    });

  if (result !== '') result = trimLast(result, ',');
  return result;
};

export const includeMedsName = (mtus, pmed) => {
  const record = pmed.find(pm => pm.type === mtus);
  return record ? record.medication : '';
};

export const includeMedsNameByFreq = (freqOrId, pmed) => {
  const record = pmed.find(pm => pm._id === freqOrId || pm.frequency === freqOrId);
  if (!record) return '';
  return formatMedicationDisplay(record);
};

export const formatMedicationDisplay = record => {
  if (!record) return '';

  let name = convertToTitleCase(record.medication || '');

  const qty = String(record.pill_qty || '').trim().replace(/^#/, '');
  if (qty) {
    name = `${name} #${qty}`;
  } else {
    name = getMedsByMedication(name);
  }

  if (record.description && record.description.trim()) {
    name = `${name} — ${record.description.trim()}`;
  }

  return name;
};

export const getMedsByMedication = v => {
  const m = {
    'Naproxen Sodium 375mg': 'Naproxen Sodium 375mg #90',
    'Omeprazole 20mg': 'Omeprazole 20mg #30',
    'Ibuprofen 600mg': 'Ibuprofen 600mg #60',
    'Ibuprofen 800mg': 'Ibuprofen 800mg #60',
    'Gabapentin 300mg': 'Gabapentin 300mg #60',
    'Cyclobenzaprine 10mg': 'Cyclobenzaprine 10mg #30',
    'Voltaren Gel 1%': 'Voltaren 1% #100g tube, Apply 4 grams to affected areas BID PRN pain',
    'Lidocaine Patch 5%':
      'Lidocaine 5% Topical Adhesive Patch, Medicated #30 Patches. Apply 1 transdermal patch to affected area once a day for 12 hours max, wait 12 hours before applying a new patch',
  };
  return m[v] ? m[v] : v;
};

/**
 * Split a medication display line into RFA Procedure vs Other Information.
 * Only splits on ", Apply" / ". Apply" so names like "Patch, Medicated #30" stay intact.
 * Lines without Apply instructions keep Procedure === Other (existing short-med behavior).
 */
export const splitMedicationProcedureAndOther = line => {
  const text = String(line || '').trim();
  if (!text) return { procedure: '', other: '' };
  const m = text.match(/^(.*?)\s*((?:,\s*Apply|\.\s*Apply)\s[\s\S]*)$/i);
  if (m) {
    return {
      procedure: m[1].trim(),
      other: m[2].replace(/^[,.]\s*/, '').trim(),
    };
  }
  return { procedure: text, other: text };
};

/** Apply splitMedicationProcedureAndOther across a multi-line med diag3 block. */
export const splitMedicationRfaColumns = diag3Block => {
  const lines = String(diag3Block || '')
    .split(/\n+/)
    .map(s => s.trim())
    .filter(Boolean);
  const procedures = [];
  const others = [];
  lines.forEach(line => {
    const { procedure, other } = splitMedicationProcedureAndOther(line);
    if (procedure) procedures.push(procedure);
    if (other) others.push(other);
  });
  return {
    procedure: procedures.length ? `${procedures.join('\n')}\n` : '',
    other: others.length ? `${others.join('\n\n')}\n` : '',
  };
};

export const replaceMedications = (str) => {
  const m = {
    'Naproxen Sodium 375mg': 'Naproxen Sodium 375mg #90',
    'Omeprazole 20mg': 'Omeprazole 20mg #30',
    'Ibuprofen 600mg': 'Ibuprofen 600mg #60',
    'Ibuprofen 800mg': 'Ibuprofen 800mg #60',
    'Gabapentin 300mg': 'Gabapentin 300mg #60',
    'Cyclobenzaprine 10mg': 'Cyclobenzaprine 10mg #30',
    'Voltaren Gel 1%': 'Voltaren 1% #100g tube, Apply 4 grams to affected areas BID PRN pain',
    'Lidocaine Patch 5%':
      'Lidocaine 5% Topical Adhesive Patch, Medicated #30 Patches. Apply 1 transdermal patch to affected area once a day for 12 hours max, wait 12 hours before applying a new patch',
  };
  return Object.entries(m).reduce((result, [key, value]) => result.replaceAll(key, value), str);
};

/**
 * Number each array entry (1., 2., …). Does not split on commas inside text.
 */
export const convertToNumberedList = v => {
  if (!Array.isArray(v)) {
    return [];
  }
  return v
    .map(item => (item != null ? String(item).trim() : ''))
    .filter(item => item !== '')
    .map((ky, idx) => {
      const normalized = ky.replace(/^\d+\.\s*/, '');
      return `${idx + 1}. ${normalized}\n`.replace(/ +/g, ' ');
    });
};

export const paragriphy = noodles => {
  // check if all items are empty or whitespace
  const hasNonEmpty = noodles.some(item => item && item.trim() !== '');
  if (!hasNonEmpty) {
    return '';
  }
  // join only non-empty, non-whitespace items
  return noodles
    .filter(item => item && item.trim() !== '')
    .join(' ');
}